import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  first:boolean = false;
  second:boolean = false;
  third:boolean = false;
  fourth:boolean = false;
  loaded:boolean = false;
  menu:boolean = false;
  constructor() {}


  showFirst(){
    this.first = !this.first;
  }

  showSecond(){
    this.second = !this.second;
  }

  showThird(){
    this.third = !this.third;
  }

  showFourth(){
    this.fourth = !this.fourth;
  }

  showMenu(){
    this.menu  = !this.menu;
  }


  loadedImg(){
    setTimeout(()=> {
    this.loaded = true;
    },1000)
  }


}




